export * from './UsersModule'
export const usersPath = '/et/company/:companyId/usersModule'


